import { combineEpics } from 'redux-observable';
import { of } from 'rxjs';
import * as ReduxObservablesEpicUtils from '@ane/core/lib/utils/ReduxObservablesEpicUtils';
import { dataSourceOverrideListActionTypes, dataSourceOverrideListLoadingAction, dataSourceOverrideListLoadedAction, } from '../ducks/DataSourceDetailOverrideList.ducks';
import { getAsyncRequestStatus } from '@ane/core/lib/models';
import DataSourceResource from '../../../DataSource.resource';
const loadDataSourceOverrideListArgs = {
    filterOnType: dataSourceOverrideListActionTypes.LOAD,
    loadResource: (payload, state) => {
        return DataSourceResource.getDataSourceOverrideList(payload.workspaceId, payload.dataSourceName);
    },
    loadingAction: dataSourceOverrideListLoadingAction,
    loadedAction: (successData, payload, error) => {
        const result = {
            status: getAsyncRequestStatus(error || ''),
            data: successData,
            error: error,
        };
        return of(dataSourceOverrideListLoadedAction(payload, result));
    },
};
export const loadDataSourceOverrideListEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(loadDataSourceOverrideListArgs);
export default combineEpics(loadDataSourceOverrideListEpic);

//# sourceMappingURL=DataSourceDetailOverrideListEpic.js.map
